import { Box, RadioButton, RadioGroup } from "@modernatx/ui-kit-react";
import React from "react";

import { AutoPayTypes, SchedulePayTypes } from "@/types/PaymentMethod";

interface InvoiceDueDateProps {
  modalType: AutoPayTypes | SchedulePayTypes;
  invoiceId?: string | string[];
}

enum InvoiceDueDateOptions {
  OnDueDate = "ON_DUE_DATE",
  OneDayPrior = "ONE_DAY_PRIOR",
  TwoDaysPrior = "TWO_DAY_PRIOR",
  SelectionDay = "SELECTION_DAY"
}

const getInvoiceDueDateRadioLabel = (
  modalType: AutoPayTypes | SchedulePayTypes,
  invoiceId?: string | string[]
): string => {
  if (
    modalType === SchedulePayTypes.IndividualInvoices ||
    modalType === SchedulePayTypes.IndividualInvoicesUpdate
  ) {
    if (Array.isArray(invoiceId)) return `Pay invoices ${invoiceId.join(", ")}`;
    else return `Pay invoice ${invoiceId}`;
  } else if (modalType === SchedulePayTypes.CheckoutSchedulePayment) {
    return "Pay this invoice";
  } else {
    return "Pay all invoices";
  }
};

const InvoiceDueDateComponent: React.FC<InvoiceDueDateProps> = ({
  modalType,
  invoiceId
}) => {
  const [invoiceDueDateSelection, setInvoiceDueDateSelection] =
    React.useState<InvoiceDueDateOptions>(InvoiceDueDateOptions.OnDueDate);

  const showSelectData =
    modalType === SchedulePayTypes.IndividualInvoices ||
    modalType === SchedulePayTypes.IndividualInvoicesUpdate;

  const radioLabel = getInvoiceDueDateRadioLabel(modalType, invoiceId);
  const handleSelectionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value as InvoiceDueDateOptions;
    setInvoiceDueDateSelection(value);
  };
  return (
    <Box sx={{ mb: "spacing-6" }}>
      <RadioGroup
        label={radioLabel}
        value={invoiceDueDateSelection}
        onChange={handleSelectionChange}
      >
        <RadioButton
          label="On the due date"
          value={InvoiceDueDateOptions.OnDueDate}
        />
        <RadioButton
          label="1 day before the due date"
          value={InvoiceDueDateOptions.OneDayPrior}
        />
        <RadioButton
          label="2 days before the due date"
          value={InvoiceDueDateOptions.TwoDaysPrior}
        />
        {showSelectData ? (
          <RadioButton
            label="Specific date"
            value={InvoiceDueDateOptions.SelectionDay}
          />
        ) : (
          <></>
        )}
      </RadioGroup>
    </Box>
  );
};

export default InvoiceDueDateComponent;
